import clsx from "clsx";
import { Meter } from "react-aria-components";
import { t } from "@lingui/core/macro";
import styles from "./CapacityMeter.module.scss";
import { Plural } from "@lingui/react/macro";
import { Text } from "@medoma/components/Text/Text";
import { Popover } from "@/components/Popover/Popover";

const TOTAL_SEGMENTS = 3;
const THREE_SEGMENT_THRESHOLD = 2 / 3;
const TWO_SEGMENT_THRESHOLD = 1 / 3;

const filledSegmentCount = (availableFraction: number) => {
  if (availableFraction <= 0) {
    return 0;
  }
  if (availableFraction > THREE_SEGMENT_THRESHOLD) {
    return 3;
  }
  if (availableFraction > TWO_SEGMENT_THRESHOLD) {
    return 2;
  }
  return 1;
};

export const CapacityMeter = ({
  availableHours,
  totalHours,
}: {
  availableHours: number;
  totalHours: number;
}) => {
  const availableFraction = totalHours > 0 ? availableHours / totalHours : 0;
  const filledSegments = filledSegmentCount(availableFraction);

  return (
    <div className={styles.popover}>
      <Popover
        trigger={{
          ariaLabel: t`Tillgänglig tid`,
          custom: (
            <Meter
              className={styles.meter}
              value={availableHours}
              minValue={0}
              maxValue={totalHours}
              aria-label={t`Tillgänglig tid`}
              formatOptions={{
                style: "unit",
                unit: "hour",
                unitDisplay: "long",
              }}
            >
              <div className={styles.bar}>
                {Array.from({ length: TOTAL_SEGMENTS }, (_, index) => (
                  <div
                    key={index}
                    className={clsx(
                      styles.segment,
                      index >= filledSegments && styles.emptySegment,
                    )}
                  />
                ))}
              </div>
              <Text element="span" size="small" color="faded">
                ~
                <Plural
                  value={availableHours}
                  one="# h tillgänglig"
                  other="# h tillgängliga"
                />
              </Text>
            </Meter>
          ),
        }}
      >
        <Text element="p">
          {t`Uppskattat antal arbetstimmar kvar efter besök och andra aktiviteter (deras planerade längder), resor (uppskattat till 25 min per hembesök) samt administration (uppskattat till 10 min per hem- och mottagningsbesök). Från passens längd dras även 30-45 min lunch/rast per pass.`}
        </Text>
        <Text element="p">
          {t`Obemannade skift samt skift av typen koordinator, inskolning och admin ingår ej.`}
        </Text>
      </Popover>
    </div>
  );
};
